import { initSpaApp, readAppData } from "@serophin/browser";
import { initBrowserClient } from "./platform/client";
import { connectApi } from "./platform/connectApi";
import { initSession } from "./platform/session";
import { migrateLegacyTheme } from "./platform/theme";
import { SiteApp } from "./SiteApp";
import { type AppData, setSeeds } from "./seeds";

if (import.meta.env.DEV) {
  import("./site.css");
}

connectApi();
initBrowserClient();
migrateLegacyTheme();

const data = readAppData<AppData>();

// A prerendered page is hydrated, which needs the first render to match it; any other (a shell) is rendered fresh.
const hydrate = data !== undefined && data.url === window.location.pathname;

if (hydrate) {
  setSeeds(data.seeds);
}

initSession({ hydrating: hydrate });

initSpaApp({ app: () => <SiteApp />, hydrate });
